module.exports = __webpack_public_path__ + "img/idea-bulb.a7bcfc32.png";